<template>
    <tasty-burger-button
        :type="buttonType"
        :active="isActive"
        :size="size"
        :color="color"
        :active-color="activeColor"
        v-on:toggle="onToggle" 
        style="height:10px;"/>
</template>

<script>
import { TastyBurgerButton } from 'vue-tasty-burgers'

export default {
  data () {
    return {
      buttonType: 'arrow',
      isActive: true,
      size: 'xs',
      color: '#72777a',
      activeColor: '#404446'
    }
  },
  methods: {
    onToggle (active) {
      // Toggle menu
      console.log(active)
    }
  },
  components: {
   'tasty-burger-button': TastyBurgerButton
 }
}
</script>

<style>
.hamburger-box{
  transform: scale(0.35) !important;
}
</style>
